import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import CheckCircleIcon from '@material-ui/icons/CheckCircle'
import WarningIcon from '@material-ui/icons/WarningRounded'
import cn from 'classnames'
import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { CAMPAIGN_INTERNAL_STATUSES } from 'shared/constants'
import { updateCampaignExtraData } from '../../gql/updateCampaignInternalStatus'
import ReviewPopup from '../Popups/ReviewPopup'
import styles from './styles'

const RequiredDataTable = ({
  classes,
  tableInfo,
  disabled,
  title,
  isDuplicateCodesExist,
  isDuplicateLinksExist,
  isCodesUploadedAlready,
  setInternalStatus,
  currentTrackingType,
  isAdmin,
}) => {
  const [isReviewPopupOpen, setIsReviewPopupOpen] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { campaignId } = useParams()

  const onCodesSubmit = async () => {
    setIsLoading(true)
    const response = await updateCampaignExtraData({
      campaignId: campaignId,
      internalStatus: CAMPAIGN_INTERNAL_STATUSES.CODE_REVIEW,
    })
    const result = await response.json()

    setInternalStatus(result.data.updateCampaignExtraData.internalStatus)
    setIsLoading(false)
    setIsReviewPopupOpen(true)
  }

  const totalInfo = tableInfo.reduce(
    (prev, item) => {
      prev.requiredQuantity += item.requiredQuantity
      prev.codesQuantity += item.codesQuantity
      prev.linksQuantity += item.linksQuantity
      return prev
    },
    { codesQuantity: 0, linksQuantity: 0, requiredQuantity: 0 },
  )

  const isWrongCodesQuantity =
    totalInfo.codesQuantity !== totalInfo.requiredQuantity ||
    totalInfo.linksQuantity !== totalInfo.requiredQuantity ||
    tableInfo.find(
      item =>
        item.requiredQuantity !== item.codesQuantity ||
        item.requiredQuantity !== item.linksQuantity,
    )

  const isErrorExist =
    isWrongCodesQuantity ||
    isDuplicateCodesExist ||
    totalInfo.codesQuantity <= 0

  return (
    <div className={classes.wrapper}>
      <div className={classes.header}>{title}</div>
      <div className={classes.table}>
        <div className={classes.tableRow}>
          <div className={cn(classes.tableCell, classes.tableCellCity)}>
            City
          </div>
          <div className={cn(classes.tableCell, classes.tableCellCodes)}>
            Codes
          </div>
          <div className={cn(classes.tableCell, classes.tableCellLinks)}>
            Links
          </div>
        </div>
        {tableInfo.map(item => {
          return (
            <div className={classes.tableRow}>
              <div className={cn(classes.tableCell, classes.tableCellCity)}>
                {item.city}
              </div>
              <div
                className={cn(
                  classes.tableCell,
                  classes.tableCellCodes,
                  item.codesQuantity !== item.requiredQuantity
                    ? classes.error
                    : '',
                )}
              >
                {`${item.codesQuantity}/${item.requiredQuantity}`}
              </div>
              <div
                className={cn(
                  classes.tableCell,
                  classes.tableCellLinks,
                  item.linksQuantity !== item.requiredQuantity
                    ? classes.error
                    : '',
                )}
              >
                {`${item.linksQuantity}/${item.requiredQuantity}`}
              </div>
            </div>
          )
        })}
        <div className={classes.tableRow}>
          <div
            className={cn(
              classes.tableCell,
              classes.bold,
              classes.tableCellCity,
            )}
          >
            Total
          </div>
          <div
            className={cn(
              classes.tableCell,
              classes.bold,
              classes.tableCellCodes,
              totalInfo.codesQuantity !== totalInfo.requiredQuantity
                ? classes.error
                : '',
            )}
          >
            {`${currentTrackingType ? totalInfo.codesQuantity : '-'}/${
              currentTrackingType ? totalInfo.requiredQuantity : '-'
            }`}
          </div>
          <div
            className={cn(
              classes.tableCell,
              classes.bold,
              classes.tableCellLinks,
              totalInfo.linksQuantity !== totalInfo.requiredQuantity
                ? classes.error
                : '',
            )}
          >
            {`${currentTrackingType ? totalInfo.linksQuantity : '-'}/${
              currentTrackingType ? totalInfo.requiredQuantity : '-'
            }`}
          </div>
        </div>
      </div>
      {isWrongCodesQuantity ? (
        <div className={classes.errorMessage}>Inaccurate number of codes</div>
      ) : null}
      {!isAdmin ? (
        <React.Fragment>
          <Button
            className={classes.button}
            variant="outlined"
            onClick={onCodesSubmit}
            disabled={
              isErrorExist || disabled || isCodesUploadedAlready || isLoading
            }
          >
            {!isCodesUploadedAlready ? (
              'Submit for review'
            ) : (
              <React.Fragment>
                Submitted <CheckCircleIcon />
              </React.Fragment>
            )}
          </Button>
          {isDuplicateCodesExist ? (
            <div className={classes.caution}>
              <WarningIcon fontSize="small" />{' '}
              <div>Caution: The uploaded data contains duplicated codes.</div>
            </div>
          ) : null}
          {isDuplicateLinksExist ? (
            <div className={classes.caution}>
              <WarningIcon fontSize="small" />{' '}
              <div>Caution: The uploaded data contains duplicated links.</div>
            </div>
          ) : null}
        </React.Fragment>
      ) : null}
      <ReviewPopup
        onClose={() => {
          setIsReviewPopupOpen(false)
        }}
        isOpen={isReviewPopupOpen}
      />
    </div>
  )
}

export default withStyles(styles)(RequiredDataTable)
